import { Lock, ShieldCheck, EyeOff, KeyRound, ServerCog, FileCheck } from "lucide-react";

const PILLARS = [
    { icon: Lock, label: "Encrypted at rest & in transit" },
    { icon: ShieldCheck, label: "Role-based access control" },
    { icon: EyeOff, label: "Anonymous shopper journeys" },
    { icon: KeyRound, label: "On-device AI inference" },
    { icon: ServerCog, label: "Multi-region cloud isolation" },
    { icon: FileCheck, label: "ISO 27001 / SOC 2 / GDPR target" },
];

const BG =
    "https://images.unsplash.com/photo-1680992046615-065f58bcb4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwc2VydmVyJTIwcm9vbXxlbnwwfHx8fDE3Nzc3MjcwNDJ8MA&ixlib=rb-4.1.0&q=85";

export default function Compliance() {
    return (
        <section
            data-testid="compliance-section"
            className="relative bg-rt-bg py-20 lg:py-24 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <img src={BG} alt="Server infrastructure" className="w-full h-full object-cover opacity-25" />
                <div className="absolute inset-0 bg-gradient-to-r from-rt-bg via-rt-bg/85 to-rt-bg/60" />
            </div>

            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-6">
                        <div className="rt-eyebrow mb-3">Trust / Security &amp; privacy</div>
                        <h2 className="rt-h2 text-3xl md:text-4xl lg:text-5xl text-white">
                            Engineered for enterprise from day one.
                        </h2>
                        <p className="mt-5 text-rt-text2 max-w-xl text-base">
                            Privacy and security are designed into every device we build.
                            ISO 27001, SOC 2 and GDPR certifications are an explicit goal — we
                            are building the controls now and will publish each certificate
                            the moment it is issued.
                        </p>
                        <p className="mt-3 text-[11px] font-mono uppercase tracking-[0.18em] text-rt-text3">
                            * No certifications issued yet — targets, not claims.
                        </p>
                    </div>

                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {PILLARS.map((p, i) => {
                                const Icon = p.icon;
                                return (
                                    <div
                                        key={i}
                                        data-testid={`compliance-pillar-${i}`}
                                        className="border border-white/15 bg-black/40 backdrop-blur px-4 py-4 flex items-center gap-3"
                                    >
                                        <Icon className="w-4 h-4 text-rt-teal shrink-0" />
                                        <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/85">
                                            {p.label}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
